<template>
  <div id="app">
    <app-header
      v-if="
        $route.name !== 'RescheduleView' && $route.name !== 'CancelConfirmedView' && $route.name !== 'ConfirmedView'
      "
    />
    <router-view />
  </div>
</template>
<script>
import AppHeader from './components/AppHeader.vue'
export default {
  name: 'App',
  components: {
    AppHeader,
  },
  data: () => ({
    //
  }),
  mounted() {
    //check height changes and send post message to iframe
    let prevHeight = 0
    const myElement = document.documentElement
    const resizeObserver = new ResizeObserver(() => {
      const dims = myElement.getBoundingClientRect()
      if (dims.height !== prevHeight) {
        prevHeight = dims.height
        window.parent.postMessage(['setHeight', dims.height], '*')
      }
    })
    resizeObserver.observe(myElement)
  },
}
</script>
